@if (isOpen()) {
<modal
  [id]="'organization-selection-modal'"
  [header]="'v2.organizationModal.switchOrganization' | translate"
  headerIcon='<svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.9006 8.21296C11.5142 8.21296 11.2005 8.53236 11.2005 8.92591V10.3518H2.38922L3.29444 9.42997C3.56817 9.15121 3.56817 8.70062 3.29444 8.42186C3.0207 8.14309 2.57825 8.14309 2.30451 8.42186L0.204251 10.5607C0.139843 10.6263 0.0887361 10.7054 0.0530316 10.7924C-0.0176772 10.9671 -0.0176772 11.1632 0.0530316 11.3371C0.0887361 11.4241 0.139843 11.5032 0.204251 11.5688L2.30451 13.7077C2.44103 13.8467 2.62025 13.9166 2.79947 13.9166C2.9787 13.9166 3.15792 13.8467 3.29444 13.7077C3.56817 13.4289 3.56817 12.9783 3.29444 12.6996L2.38922 11.7777H11.9006C12.2871 11.7777 12.6007 11.4583 12.6007 11.0648V8.92591C12.6007 8.53236 12.2871 8.21296 11.9006 8.21296Z" fill="currentColor"/>
    <path d="M13.947 3.66289C13.9113 3.57591 13.8602 3.49678 13.7957 3.43119L11.6955 1.29233C11.4218 1.01356 10.9793 1.01356 10.7056 1.29233C10.4318 1.57109 10.4318 2.02168 10.7056 2.30044L11.6108 3.22229H2.09939C1.71294 3.22229 1.3993 3.54169 1.3993 3.93524V6.0741C1.3993 6.46765 1.71294 6.78706 2.09939 6.78706C2.48584 6.78706 2.79947 6.46765 2.79947 6.0741V4.6482H11.6108L10.7056 5.57004C10.4318 5.84881 10.4318 6.29939 10.7056 6.57816C10.8421 6.71719 11.0213 6.78706 11.2005 6.78706C11.3797 6.78706 11.559 6.71719 11.6955 6.57816L13.7957 4.4393C13.8602 4.37371 13.9113 4.29457 13.947 4.20759C14.0177 4.03363 14.0177 3.83686 13.947 3.66289Z" fill="currentColor"/>
    </svg>
    '
  [closeButtonEnabled]="true"
  [widthClass]="'tw-w-[1088px] tw-overflow-hidden'"
  [heightClass]="'tw-h-[800px]'"
  (onCloseModal)="closeModalSilently()"
>
  <div slot="body" class="tw-bg-gray-100 dark:tw-bg-gray-800 tw-h-[740px] tw-flex tw-flex-col tw--mx-6 tw--my-4">
    <!-- Search Bar -->
    <div class="tw-px-6 tw-py-4">
      <div class="tw-relative">
        <div class="tw-absolute tw-inset-y-0 tw-flex tw-items-center tw-pointer-events-none tw-start-0 tw-ps-3">
          <svg class="tw-h-5 tw-w-5 tw-text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </div>
        <input
          type="text"
          [ngModel]="searchQuery()"
          (ngModelChange)="onSearchInputChange($event)"
          (keypress)="onSearchKeyPress($event)"
          [placeholder]="'v2.organizationModal.searchPlaceholder' | translate"
          class="tw-block tw-w-full tw-h-12 tw-py-2 tw-pb-3 tw-border tw-border-gray-300 dark:tw-border-gray-600 tw-rounded-md tw-leading-5 tw-bg-white dark:tw-bg-gray-700 tw-text-gray-900 dark:tw-text-white tw-placeholder-gray-500 dark:tw-placeholder-gray-400 focus:tw-outline-none focus:tw-placeholder-gray-400 focus:tw-ring-1 focus:tw-ring-blue-500 focus:tw-border-blue-500 sm:tw-text-sm tw-ps-10 tw-pe-10"
        />
        <!-- Clear Search Button -->
        @if (searchQuery().trim().length) {
        <button
          (click)="clearSearch()"
          type="button"
          class="tw-absolute tw-inset-y-0 tw-flex tw-items-center tw-cursor-pointer tw-text-gray-400 hover:tw-text-gray-600 dark:hover:tw-text-gray-300 tw-end-0 tw-pe-3"
        >
          <svg class="tw-h-5 tw-w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        }
      </div>
    </div>

    <!-- Content Area - Cards -->
    <div #scrollContainer class="tw-px-6 tw-overflow-y-auto tw-mb-3 tw-flex-1 scrollable-content" (scroll)="onScroll($event)">
      <!-- Unified Skeleton Loading State -->
      @if ((isLoading() || isSearching()) || (isLoadingMore() && hasMorePages())) {
      <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-1 md:tw-justify-center lg:tw-grid-cols-2 lg:tw-justify-start tw-gap-4">
        @for (i of [1,2,3,4]; track i) {
        <div class="tw-border tw-rounded-lg tw-p-4 tw-bg-gray-50 dark:tw-bg-gray-800 tw-w-128 tw-h-36 tw-relative tw-overflow-hidden">
          <!-- Shimmer effect -->
          <div
            class="tw-absolute tw-inset-0 tw-bg-gradient-to-r tw-from-transparent tw-via-white/20 tw-to-transparent tw-animate-pulse tw-transform tw-translate-x-[-100%] tw-animate-[shimmer_2s_infinite]"
          ></div>
          <div class="tw-flex tw-gap-3 tw-relative tw-z-10">
            <div class="tw-w-28 tw-h-28 tw-bg-gray-200 dark:tw-bg-gray-700 tw-rounded-xl tw-animate-pulse"></div>
            <div class="tw-flex-1 tw-space-y-2">
              <div class="tw-h-5 tw-bg-gray-200 dark:tw-bg-gray-700 tw-rounded tw-w-3/4 tw-animate-pulse"></div>
              <div class="tw-h-4 tw-bg-gray-200 dark:tw-bg-gray-700 tw-rounded tw-w-1/2 tw-animate-pulse"></div>
              <div class="tw-flex tw-gap-2">
                <div class="tw-h-6 tw-w-12 tw-bg-gray-200 dark:tw-bg-gray-700 tw-rounded tw-animate-pulse"></div>
                <div class="tw-h-6 tw-w-12 tw-bg-gray-200 dark:tw-bg-gray-700 tw-rounded tw-animate-pulse"></div>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
      }

      <!-- Error State -->
      @if (error() && !isLoading() && !isSearching()) {
      <div class="tw-flex tw-items-center tw-justify-center tw-py-20">
        <div class="tw-flex tw-flex-col tw-items-center tw-space-y-4 tw-text-center">
          <svg class="tw-h-12 tw-w-12 tw-text-red-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
            />
          </svg>
          <div>
            <h3 class="tw-text-lg tw-font-medium tw-text-gray-900 dark:tw-text-white">{{ 'v2.organizationModal.errorTitle' | translate }}</h3>
            <p class="tw-text-gray-600 dark:tw-text-gray-400 tw-mt-2">{{ error() }}</p>
          </div>
          <button (click)="_loadOrganizations()" class="tw-mt-4 tw-px-4 tw-py-2 tw-bg-blue-600 tw-text-white tw-rounded-md tw-hover:tw-bg-blue-700 tw-transition-colors">
            {{ 'v2.organizationModal.retry' | translate }}
          </button>
        </div>
      </div>
      }

      <!-- Organizations Grid -->
      @if (!isLoading() && !isSearching() && !error() && filteredOrganizations().length > 0) {
      <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-1 md:tw-justify-center lg:tw-grid-cols-2 lg:tw-justify-start tw-gap-4">
        @for (org of filteredOrganizations(); track org.id) {
        <app-organization-card
          class="tw-flex tw-content-center"
          [organization]="org"
          [isSelected]="isCurrentOrganization(org)"
          [isClickable]="true"
          [showManagedBy]="true"
          (cardClick)="onOrganizationSelected(org)"
        />
        }
      </div>

      <!-- Infinite Scroll Loading Indicator - Skeleton Cards -->
      @if (isLoadingMore() && hasMorePages()) {
      <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-1 md:tw-justify-center lg:tw-grid-cols-2 lg:tw-justify-start tw-gap-4 tw-mt-4">
        @for (i of [1,2,3,4]; track i) {
        <div class="tw-border tw-rounded-lg tw-p-4 tw-bg-gray-50 dark:tw-bg-gray-800 tw-w-128 tw-h-36 tw-relative tw-overflow-hidden">
          <!-- Shimmer effect -->
          <div
            class="tw-absolute tw-inset-0 tw-bg-gradient-to-r tw-from-transparent tw-via-white/20 tw-to-transparent tw-transform tw-translate-x-[-100%] tw-animate-[shimmer_2s_infinite]"
          ></div>
          <div class="tw-flex tw-gap-3 tw-relative tw-z-10">
            <div class="tw-w-28 tw-h-28 tw-bg-gray-200 dark:tw-bg-gray-700 tw-rounded-xl tw-animate-pulse"></div>
            <div class="tw-flex-1 tw-space-y-2">
              <div class="tw-h-5 tw-bg-gray-200 dark:tw-bg-gray-700 tw-rounded tw-w-3/4 tw-animate-pulse"></div>
              <div class="tw-h-4 tw-bg-gray-200 dark:tw-bg-gray-700 tw-rounded tw-w-1/2 tw-animate-pulse"></div>
              <div class="tw-flex tw-gap-2">
                <div class="tw-h-6 tw-w-12 tw-bg-gray-200 dark:tw-bg-gray-700 tw-rounded tw-animate-pulse"></div>
                <div class="tw-h-6 tw-w-12 tw-bg-gray-200 dark:tw-bg-gray-700 tw-rounded tw-animate-pulse"></div>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
      }

      <!-- End of Results Indicator -->
      @if (!hasMorePages() && !isLoadingMore()) {
      <div class="tw-flex tw-justify-center tw-items-center tw-py-8">
        <span class="tw-text-sm tw-text-gray-500 dark:tw-text-gray-400">{{ 'v2.organizationModal.noMoreOrganizations' | translate }}</span>
      </div>
      }

      <!-- Load More Button - Only show on API error -->
      @if (hasMorePages() && !isLoadingMore() && error()) {
      <div class="tw-flex tw-justify-center tw-items-center tw-py-4">
        <button (click)="loadMoreOrganizations()" class="tw-px-4 tw-py-2 tw-bg-blue-600 tw-text-white tw-rounded-md tw-hover:tw-bg-blue-700 tw-transition-colors">Load More</button>
      </div>
      } }

      <!-- No Results State - Only show when searching and no results -->
      @if (!isLoading() && !isSearching() && !error() && filteredOrganizations().length === 0 && searchQuery().trim().length > 0) {
      <div class="tw-flex tw-items-center tw-justify-center tw-h-full tw-pb-20">
        <div class="tw-text-center">
          <svg class="tw-mx-auto tw-h-24 tw-w-24 tw-text-gray-400 dark:tw-text-gray-200" viewBox="0 0 65 65" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_no_orgs_search)">
              <path
                d="M60.9444 57.3888H57.3888V7.6111C58.3318 7.6111 59.2362 7.2365 59.903 6.5697C60.5698 5.90291 60.9444 4.99854 60.9444 4.05555C60.9444 3.11256 60.5698 2.20819 59.903 1.5414C59.2362 0.874601 58.3318 0.5 57.3888 0.5H7.6111C6.66811 0.5 5.76374 0.874601 5.09695 1.5414C4.43015 2.20819 4.05555 3.11256 4.05555 4.05555C4.05555 4.99854 4.43015 5.90291 5.09695 6.5697C5.76374 7.2365 6.66811 7.6111 7.6111 7.6111V57.3888H4.05555C3.11256 57.3888 2.20819 57.7634 1.5414 58.4302C0.874601 59.097 0.5 60.0014 0.5 60.9444C0.5 61.8874 0.874601 62.7917 1.5414 63.4585C2.20819 64.1253 3.11256 64.4999 4.05555 64.4999H60.9444C61.8874 64.4999 62.7917 64.1253 63.4585 63.4585C64.1253 62.7917 64.4999 61.8874 64.4999 60.9444C64.4999 60.0014 64.1253 59.097 63.4585 58.4302C62.7917 57.7634 61.8874 57.3888 60.9444 57.3888ZM18.2778 14.7222C18.2778 13.7792 18.6524 12.8748 19.3192 12.208C19.9859 11.5413 20.8903 11.1667 21.8333 11.1667H25.3889C26.3318 11.1667 27.2362 11.5413 27.903 12.208C28.5698 12.8748 28.9444 13.7792 28.9444 14.7222V18.2778C28.9444 19.2207 28.5698 20.1251 27.903 20.7919C27.2362 21.4587 26.3318 21.8333 25.3889 21.8333H21.8333C20.8903 21.8333 19.9859 21.4587 19.3192 20.7919C18.6524 20.1251 18.2778 19.2207 18.2778 18.2778V14.7222ZM18.2778 32.5V28.9444C18.2778 28.0014 18.6524 27.097 19.3192 26.4303C19.9859 25.7635 20.8903 25.3889 21.8333 25.3889H25.3889C26.3318 25.3889 27.2362 25.7635 27.903 26.4303C28.5698 27.097 28.9444 28.0014 28.9444 28.9444V32.5C28.9444 33.4429 28.5698 34.3473 27.903 35.0141C27.2362 35.6809 26.3318 36.0555 25.3889 36.0555H21.8333C20.8903 36.0555 19.9859 35.6809 19.3192 35.0141C18.6524 34.3473 18.2778 33.4429 18.2778 32.5ZM39.6111 57.3888H25.3889V46.7222C25.3889 45.7792 25.7635 44.8748 26.4303 44.208C27.097 43.5412 28.0014 43.1666 28.9444 43.1666H36.0555C36.9985 43.1666 37.9029 43.5412 38.5697 44.208C39.2365 44.8748 39.6111 45.7792 39.6111 46.7222V57.3888ZM46.7222 32.5C46.7222 33.4429 46.3476 34.3473 45.6808 35.0141C45.014 35.6809 44.1096 36.0555 43.1666 36.0555H39.6111C38.6681 36.0555 37.7637 35.6809 37.0969 35.0141C36.4301 34.3473 36.0555 33.4429 36.0555 32.5V28.9444C36.0555 28.0014 36.4301 27.097 37.0969 26.4303C37.7637 25.7635 38.6681 25.3889 39.6111 25.3889H43.1666C44.1096 25.3889 45.014 25.7635 45.6808 26.4303C46.3476 27.097 46.7222 28.0014 46.7222 28.9444V32.5ZM46.7222 18.2778C46.7222 19.2207 46.3476 20.1251 45.6808 20.7919C45.014 21.4587 44.1096 21.8333 43.1666 21.8333H39.6111C38.6681 21.8333 37.7637 21.4587 37.0969 20.7919C36.4301 20.1251 36.0555 19.2207 36.0555 18.2778V14.7222C36.0555 13.7792 36.4301 12.8748 37.0969 12.208C37.7637 11.5413 38.6681 11.1667 39.6111 11.1667H43.1666C44.1096 11.1667 45.014 11.5413 45.6808 12.208C46.3476 12.8748 46.7222 13.7792 46.7222 14.7222V18.2778Z"
                fill="#9CA3AF"
              />
            </g>
            <defs>
              <clipPath id="clip0_no_orgs_search">
                <rect width="63.9999" height="63.9999" fill="white" transform="translate(0.5 0.5)" />
              </clipPath>
            </defs>
          </svg>
          <h3 class="tw-mt-2 tw-text-sm tw-font-medium tw-text-gray-900 dark:tw-text-white">{{ 'v2.organizationModal.noResultsFound' | translate }}</h3>
        </div>
      </div>
      }

      <!-- Empty State - Only show when not searching and no organizations -->
      @if (!isLoading() && !isSearching() && !error() && organizations().length === 0 && searchQuery().trim().length === 0) {
      <div class="tw-flex tw-items-center tw-justify-center tw-py-20">
        <div class="tw-text-center">
          <svg class="tw-mx-auto tw-h-12 tw-w-12 tw-text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
            />
          </svg>
          <h3 class="tw-mt-2 tw-text-sm tw-font-medium tw-text-gray-900 dark:tw-text-white">{{ 'v2.organizationModal.noOrganizations' | translate }}</h3>
          <p class="tw-mt-1 tw-text-sm tw-text-gray-500 dark:tw-text-gray-400">{{ 'v2.organizationModal.noOrganizationsDesc' | translate }}</p>
        </div>
      </div>
      }
    </div>
  </div>
</modal>
}
